import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { register } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const result = await register(email, password);

        if (result.ok) {
            // Redirect to verification page
            navigate('/verify');
        } else if (result.status === 409) {
            setError('Email already exists. Please try logging in.');
        } else {
            setError('Registration failed. Please try again.');
        }

        setLoading(false);
    };

    return (
        <div className="bg-dark text-light d-flex align-items-center" style={{ minHeight: '100vh' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-sm-10 col-md-8 col-lg-6">
                        <div className="card bg-secondary-subtle text-light shadow-lg">
                            <div className="card-body">
                                <h3 className="mb-3">Create Account</h3>

                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            autoComplete="email"
                                            required
                                            disabled={loading}
                                        />
                                        <small className="form-text text-secondary">
                                            You'll need to verify this email address.
                                        </small>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            autoComplete="new-password"
                                            required
                                            disabled={loading}
                                            minLength={8}
                                        />
                                        <small className="form-text text-secondary">
                                            Minimum 8 characters.
                                        </small>
                                    </div>

                                    <button
                                        className="btn btn-primary w-100"
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Creating account...
                                            </>
                                        ) : (
                                            'Register'
                                        )}
                                    </button>
                                </form>

                                <p className="mt-3 small mb-0">
                                    Already have an account? <Link to="/login">Sign in</Link>.
                                </p>
                            </div>
                        </div>

                        <p className="text-center mt-3">
                            <a className="link-light" href="/">← Back to site</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;

